import { api } from "../../../lib/axios";
import type { PassageIncidentType, TourneeClosurePreview, TourneeLiveResponse } from "../types/execution.types";

/** Invalide les vues admin (exécution passages, listes) après mutation tournée / passage. */
export function notifyAdminExecutionPassagesRefresh(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("adminExecutionPassagesRefresh"));
}

export async function fetchTourneeLive(tourneeId: string | number): Promise<TourneeLiveResponse> {
  const res = await api.get(`/tournees/${tourneeId}/live`);
  return res.data as TourneeLiveResponse;
}

export async function fetchTourneeClosurePreview(tourneeId: string | number): Promise<TourneeClosurePreview> {
  const res = await api.get(`/tournees/${tourneeId}/closure-preview`);
  return res.data as TourneeClosurePreview;
}

export async function startTourneeExecution(tourneeId: string | number) {
  await api.post(`/tournees/${tourneeId}/start`);
  notifyAdminExecutionPassagesRefresh();
}

export async function pauseTourneeExecution(tourneeId: string | number) {
  await api.post(`/tournees/${tourneeId}/pause`);
}

export async function resumeTourneeExecution(tourneeId: string | number) {
  await api.post(`/tournees/${tourneeId}/resume`);
}

export async function completeTourneeExecution(
  tourneeId: string | number,
  options?: { closureReason?: string }
): Promise<{
  success: boolean;
  tournee: unknown;
  closeWarnings: string[];
  closure?: {
    severity: string;
    qualityScore: number;
    closureReason: string | null;
    warningReasons: string[];
    infoReasons: string[];
    summary: Record<string, unknown>;
  };
}> {
  const res = await api.post(`/tournees/${tourneeId}/complete`, {
    closureReason: options?.closureReason,
  });
  notifyAdminExecutionPassagesRefresh();
  return res.data as {
    success: boolean;
    tournee: unknown;
    closeWarnings: string[];
    closure?: {
      severity: string;
      qualityScore: number;
      closureReason: string | null;
      warningReasons: string[];
      infoReasons: string[];
      summary: Record<string, unknown>;
    };
  };
}

export async function startPassageExecution(passageId: number) {
  await api.post(`/passages/${passageId}/start`, {});
}

export async function completePassageExecution(passageId: number) {
  await api.post(`/passages/${passageId}/complete`, {});
}

export async function failPassageExecution(passageId: number) {
  await api.post(`/passages/${passageId}/fail`, {});
}

export async function reportPassageIncident(
  passageId: number,
  payload: { type: PassageIncidentType; description: string }
) {
  await api.post(`/passages/${passageId}/incident`, payload);
}
